module.exports = __webpack_public_path__ + "img/blue-jays.806364c9.svg";